<template>
  <div class="book">
    <div class="middle-main">
      <!-- <column-title title="購物車結算" desc="" /> -->
      <h2>購物車結算</h2>
      <div class="order-info">
        <el-row class="justify-center">
          <!-- <el-col :span="6"><div></div></el-col> -->
          <el-col :span="24">
            <div class="order-details">
              <!-- <h2>訂購明細</h2> -->

              <!-- <div v-for="item in myCartList.rows" :key="item.id" class="book-info-item justify-between">
                <img :src="item.image[0]" class="magazine-img" />
                <div class="info flex-col">
                  <h3>{{ item.title }}</h3>
                  <span>規格: <b>數位版</b></span>
                  <span>數量: <b>1</b></span>
                </div>
              </div> -->
              <el-row class="row-list" v-for="item in myCartList.rows" :key="item.id">
                <el-col :span="17">
                  <div class="book-info items-center">
                    <img :src="item.image[0]" class="magazine-img" />
                    <div class="info">
                      <h3>{{ item.title }}</h3>
                      <svg-icon icon-class="pdf2" />
                      <!-- <span>規格: <b>數位版</b></span> -->
                    </div>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="type">{{ L('電子版') }}</div>
                </el-col>

                <el-col :span="3">
                  <div class="total-price">HK$ <em>{{ item.price }}</em></div>
                </el-col>
                <el-col :span="1">
                  <div class="num">x 1</div>
                </el-col>
              </el-row>
              <!-- <div style="padding: 15px 0">
                <div class="others-item justify-between items-center">
                  <h4>合計</h4>
                  <span>HK$ {{ total }}</span>
                </div>
                <div class="others-item justify-between items-center">
                  <h4>運費</h4>
                  <span>0</span>
                </div>
              </div> -->
              <!-- <div class="total-price others-item justify-between items-center">
                <h4>總額</h4>
                <span>HK$ {{ total }}</span>
              </div>
              <div class="pay-price others-item justify-between items-center">
                <h4>應付金額</h4>
                <span>HK$ {{ total }}</span>
              </div> -->
            </div>
            <div class="pay-info flex-col">
              <!-- <h3>輸入您的E-MAIL</h3>
              <el-input v-model="form.email" placeholder="Email"></el-input>
              <p>還不是我們的會員嗎? <a href="">加入會員</a></p> -->
              <h3>付款方式</h3>
              <el-radio v-model="radio" label="1">
                (ECpay提供 : 信用卡、ATM轉帳支付)
              </el-radio>
              <!-- <el-radio v-model="radio" label="2">
                (ECpay提供 : 信用卡、ATM轉帳支付)
              </el-radio> -->
              <div class="next-btn justify-end items-center">
                <div class="total-price"><span>{{ L('合计：') }}</span>HK$ <em>{{ total }}</em></div>
                <div class="next" @click="fnToBuy">{{ L('立即付款') }}</div>
              </div>
              <!-- <button @click="fnToBuy">確認結帳</button> -->
            </div>
          </el-col>
          <!-- <el-col :span="6"></el-col> -->

          <!-- <el-col :span="12">
            <div class="pay-info flex-col">
              <h3>輸入您的E-MAIL</h3>
              <el-input v-model="form.email" placeholder="Email"></el-input>
              <p>還不是我們的會員嗎? <a href="">加入會員</a></p>
              <h3>付款方式</h3>
              <el-radio v-model="radio" label="1">
                (ECpay提供 : 信用卡、ATM轉帳支付)
              </el-radio>
              <el-radio v-model="radio" label="2">
                (ECpay提供 : 信用卡、ATM轉帳支付)
              </el-radio>
              <button  @click="fnToBuy">確認結帳</button>
            </div>
          </el-col> -->
        </el-row>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";
import ColumnTitle from "../common/column-title.vue";

import { createCartOrder } from "@/assets/api/magazine.js";
export default {
  components: {
    ColumnTitle,
  },
  data() {
    return {
      detailsRes: {},
      radio: "1",
      form: {
        email: "",
      },
      // total: 0,
      myCartListRes: [],
    };
  },
  computed: {
    // ...mapState(["isPc", "myCartList"]),
    ...mapState({
      isPc: "isPc",
      myCartList: (state) => {
        console.log(state.myCartList.rows);
        state.myCartList.rows = state.myCartList.rows.map((item) => {
          item.image = item.image.split(",");
          item.image = item.image.map((it) => {
            it = !/^http/.test(it) ? "https://ts960.com/tsMgz/" + it : it;
            return it;
          });
          // vm.total+=item.price
          return item;
        });
        return state.myCartList;
      },
    }),
    total() {
      let totalPrice = 0;
      this.myCartList.rows.map((item) => {
        totalPrice += item.price;
      });
      return totalPrice;
    },
  },
  created() {
    this.$store.dispatch("getMyCart");
    // this.myCartListRes = this.myCartList.rows.map((item) => {
    //   item.image = item.image.split(",");
    //   item.image = item.image.map((it) => {
    //     it = !/^http/.test(it) ? this.$imgUrl + it : it;
    //     return it;
    //   });
    //   this.total += item.price;
    //   return item;
    // });
  },
  methods: {
    fnToBuy() {
      createCartOrder().then((res) => {
        if (res.data.code == 500) {
          console.log("請先登錄");
          this.$router.push({ path: '/member-center?type=3' });
        } else {
          this.$router.push({ path: '/member-center?type=3' });
          window.open(res.data.data, "_blank");
          // window.open('https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=EC-0WU77850R1826910E', "_blank");
          console.log(res);
        }
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>

<style lang="less" scoped>
.book {
  padding-top: 57px;

  h2 {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 32px;
    color: #2C2C2E;
    line-height: 42px;
    text-align: left;
    font-style: normal;
    margin-bottom: 40px;
  }

  .order-info {

    // padding-top: 40px;
    .pay-info {
      margin-top: 40px;

      // margin-left: 156px;
      h3 {
        font-family: NotoSansCJKTC;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 24px;
        letter-spacing: 9.6px;
        text-align: left;
        color: #000;
        margin-bottom: 16px;
      }

      p {
        font-family: NotoSansCJKTC;
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.44;
        letter-spacing: 2.25px;
        text-align: left;
        color: #878787;
        margin-top: 24px;
        margin-bottom: 74px;

        a {
          color: #e13133;
          text-decoration: underline;
        }
      }

      button {
        margin-top: 50px;
        padding: 15px 0;
        border-radius: 8px;
        background-color: #e13133;
        font-family: NotoSansCJKTC;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 4.2px;
        text-align: center;
        color: #fff;
        border: none;
        cursor: pointer;
      }
    }

    .order-details {
      // background-color: #f9f9f9;
      // border-radius: 8px;
      // padding: 34px 26px 51px 29px;

      h2 {
        font-family: NotoSansCJKTC;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 20px;
        letter-spacing: 8.4px;
        text-align: left;
        color: #252525;
        margin-bottom: 27px;
      }

      .book-info-item {
        padding: 30px 0;
        border-bottom: 1px solid #E5E5EA;

        .info {
          display: flex;
          align-items: center;

          svg {
            width: 78px;
            height: 32px;
            background: #E2291E;
            border-radius: 19px;
            padding: 6px 10px;
            margin-left: 12px;
          }
        }

        img {
          width: 100px;
          height: 134px;
          object-fit: cover;
          border-radius: 4px;
          margin-right: 20px;
        }

        h3 {
          font-family: NotoSansCJKTC;
          font-size: 16px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 3;
          letter-spacing: 2.4px;
          text-align: left;
          color: #222;
        }

        span {
          font-family: NotoSansCJKTC;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.67;
          letter-spacing: 3.6px;
          text-align: left;
          color: #959595;

          b {
            color: #000;
          }
        }

        .info {
          flex: 1;
        }

        h6 {
          font-family: NotoSansCJKTC;
          font-size: 10px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 2;
          letter-spacing: 3px;
          text-align: right;
          color: #959595;
          margin-bottom: 16px;
        }

        .el-icon-close {
          font-size: 20px;
          color: #959595;
          cursor: pointer;
        }

        .el-icon-close:hover {
          color: #000;
        }

        .price {
          margin-top: 34px;
          font-family: Lato;
          font-size: 15px;
          font-weight: normal;
          font-stretch: normal;
          font-style: italic;
          line-height: 1.87;
          letter-spacing: normal;
          text-align: right;
          color: #000;
        }
      }

      .others-item {
        h4 {
          font-family: NotoSansCJKTC;
          font-size: 15px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 22px;
          letter-spacing: 4.5px;
          text-align: left;
          color: #010101;
        }

        span {
          font-family: Lato;
          font-size: 15px;
          font-weight: normal;
          font-stretch: normal;
          font-style: italic;
          line-height: 1.87;
          letter-spacing: normal;
          text-align: right;
          color: #000;
        }
      }

      .total-price {
        // padding: 30px 0;
        // border-top: 1px dashed #b8b8b8;
        // border-bottom: 1px dashed #b8b8b8;
      }

      .pay-price {
        padding-top: 30px;

        h4 {
          font-family: NotoSansCJKTC;
          font-size: 20px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 2.4;
          letter-spacing: 12px;
          text-align: left;
          color: #252525;
        }

        span {
          font-family: Lato;
          font-size: 30px;
          font-weight: bold;
          font-stretch: normal;
          font-style: italic;
          line-height: 0.48;
          letter-spacing: normal;
          text-align: right;
          color: #000;
        }
      }
    }
  }
}

.row-list {
  padding: 28px 0;
  border-bottom: 1px solid #ebebeb;
  display: flex;
  align-items: center;

  .book-info {
    img {
      width: 100px;
      height: 134px;
      border-radius: 4px;
      margin-right: 20px;
    }

    h3 {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 18px;
      color: #2C2C2E;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }

    span {
      font-family: NotoSansCJKTC;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.67;
      letter-spacing: 3.6px;
      text-align: left;
      color: #959595;

      b {
        color: #000;
      }
    }
  }

  .type {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #2C2C2E;
    line-height: 19px;
    text-align: left;
    font-style: normal;
  }

  .price {
    font-family: Lato;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: italic;
    line-height: 1.87;
    letter-spacing: normal;
    color: #959595;
  }

  .num {

    .el-input-number--mini {
      width: 90px;
      height: 40px;
      line-height: 40px;
    }
  }

  .total-price {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 16px;
    color: #FF3B30;
    line-height: 21px;
    text-align: left;
    font-style: normal;

    em {
      font-size: 24px;
    }
  }

  .delete {
    span {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #636366;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      cursor: pointer;
    }

    span:hover {
      color: #E2291E;
    }
  }
}

.next-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 80px;

  .total-price {
    margin-right: 30px;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 16px;
    color: #FF3B30;
    line-height: 21px;
    text-align: right;
    font-style: normal;

    span {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #2C2C2E;
      line-height: 19px;
      text-align: right;
      font-style: normal;
    }

    em {
      font-size: 24px;
    }
  }

  .next {
    cursor: pointer;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 50px;
    text-align: center;
    font-style: normal;
    text-align: center;
    color: #fff;
    width: 200px;
    height: 50px;
    background: #E2291E;
    border-radius: 25px;
  }

}

.other-news {
  padding: 40px 0 80px;
  margin-top: 100px;
}

@media screen and (max-width: 768px) {
  .book {
    padding-top: 0;

    .order-info {
      margin: 0 20px;
    }
  }

  .other-news {
    padding: 40px 0 80px;
    margin-top: 0;
  }
}
</style>
<style>
.pay-info .el-input__inner {
  border: none;
  border-bottom: 1px solid #e1e1e1;
}

.el-radio {
  margin-bottom: 16px;
}

.pay-info .el-radio__input.is-checked+.el-radio__label,
.pay-info .el-radio__label {
  font-family: NotoSansCJKTC;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.54;
  letter-spacing: 1.4px;
  text-align: left;
  color: #959595;
}

.pay-info .el-radio__input.is-checked .el-radio__inner {
  border-color: #b7b7b7;
  background: #fff;
}

.pay-info .el-radio__inner::after {
  width: 8px;
  height: 8px;
  background-color: #e50505;
}
</style>



// WEBPACK FOOTER //
// src/views/magazine-cart-order/index.vue